import { render, staticRenderFns } from "./PillButton.vue?vue&type=template&id=048b5dec&scoped=true&"
import script from "./PillButton.vue?vue&type=script&lang=js&"
export * from "./PillButton.vue?vue&type=script&lang=js&"
import style0 from "./PillButton.vue?vue&type=style&index=0&id=048b5dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b5dec",
  null
  
)

component.options.__file = "PillButton.vue"
export default component.exports